import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const ExtrasWrapper = styled.div`
  padding: 0 20px;

  ${media.md`
    padding: 0;
    flex-direction: row;
  `}
`;
